/**
 * @module labelHelpers
 * Helper functions for computing singular/plural labels based on array length
 */

/**
 * Get the appropriate floor label based on the number of floors.
 * Returns singular "FLOOR" for 0 or 1 floors, plural "FLOORS" for 2+.
 *
 * @param {Array<string>|null|undefined} floors - Array of floor values
 * @returns {string} "FLOOR" or "FLOORS"
 */
export function getFloorLabel(floors) {
  return floors?.length > 1 ? "FLOORS" : "FLOOR"
}

/**
 * Get the appropriate room label based on the number of rooms.
 * Returns singular "ROOM" for 0 or 1 rooms, plural "ROOMS" for 2+.
 *
 * @param {Array<string>|null|undefined} rooms - Array of room values
 * @returns {string} "ROOM" or "ROOMS"
 */
export function getRoomLabel(rooms) {
  return rooms?.length > 1 ? "ROOMS" : "ROOM"
}

/**
 * Get the modal key for floors (title case).
 * Returns "Floor" for 0 or 1 floors, "Floors" for 2+.
 *
 * @param {Array<string>|null|undefined} floors - Array of floor values
 * @returns {string} "Floor" or "Floors"
 */
export function getFloorModalKey(floors) {
  return floors?.length > 1 ? "Floors" : "Floor"
}

/**
 * Get the modal key for rooms (title case).
 * Returns "Room" for 0 or 1 rooms, "Rooms" for 2+.
 *
 * @param {Array<string>|null|undefined} rooms - Array of room values
 * @returns {string} "Room" or "Rooms"
 */
export function getRoomModalKey(rooms) {
  return rooms?.length > 1 ? "Rooms" : "Room"
}
